export const courseStatusesFilterables = [
  'priority',
  'member_name',
  'status',
];
